import { useState } from "react";
import FormCheckboxSingle from "./FormCheckboxSingle";

export default function FormCheckbox({
  state,
  setState,
  newButtonLabel,
  type = 1,
  maxFive = 999,
  maxFour = 999,
  gozineType = 1,
}) {
 

  const formCheckboxJSX = Object.keys(state).map((single, index) => (
    <FormCheckboxSingle
      gozineType={gozineType}
      maxFour={maxFour}
      maxFive={maxFive}
      type={type}
      index={index}
      key={index}
      single={single}
      state={state}
      handleState={setState}
     
    />
  ));
  const handleAdd = () => {
    setState({
      ...state,
      newItem: { newItem: true },
    });
  };
  // console.log(state);
  return (
    <div>
      {formCheckboxJSX}
      {newButtonLabel ? (
        <button
          className="flex w-[250px] mt-6 justify-center items-center rounded-lg border-2 border-gray-400 placeholder-gray-300 outline-none focus:border-main-color hover:bg-[#5B5CFF] hover:text-white transition duration-300"
          onClick={handleAdd}
        >
          <span className="text-yellow-500 font-extrabold text-[1.3rem] m-2">
            +
          </span>
          <span>{newButtonLabel}</span>
        </button>
      ) : null}
    </div>
  );
}
